import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAlerts } from "../../contexts/AlertsContext";
import { useApiClient } from "../../contexts/ApiClientContext";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import DialogWindowType from "../common/dialog_window/DialogWindowType";
import AlertMessageType from "../common/alert_message/AlertMessageType";
import APIEndPoints from "../../utils/APIEndPoints";

function UserRoleUpdate() {
  const navigate = useNavigate();
  const alertsManager = useAlerts();
  const apiClient = useApiClient();
  const userMessageRef = useRef<string>("");

  const handleRequest = () => {
    let user_upgrade_request_message =
      "This is an automated message generated at the request of a user. The user requests approval for elevated access rights.";

    user_upgrade_request_message += "\n\n Attached below is the user's provided justification: \n\n ";
    user_upgrade_request_message += userMessageRef.current;

    const body = {
      category: "role_request",
      message: user_upgrade_request_message,
    };

    apiClient
      ?.post({
        url: APIEndPoints.EMAILS.NEW,
        body: body,
      })
      .then(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.SUCCESS,
          message: "Request submitted successfully. An administrator will review your request shortly.",
        });
      })
      .catch(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.ERROR,
          message: "Failed to send request. Please try again later.",
        });
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md">
        <div className="mb-6 text-center">
          <svg
            className="mx-auto h-16 w-16 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4 text-center">
          Request Role Upgrade
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Your current role limits certain actions. Please submit a formal request below,
          and an administrator will review your application.
        </p>

        <div className="flex gap-4">
          <Button
            label="Request"
            purpose={ButtonAction.INFO}
            isSubmit={false}
            onClick={() => {
              alertsManager.showDialogWindow({
                type: DialogWindowType.CONTACTFORM,
                message:           "This will prompt a message being sent to each existing board member to review your formal application for you being granted specialist role. This will grant you the right to contribute data to the repository. Are you sure you want to submit this formal request?",
                cancelLabel: "Cancel",
                confirmLabel: "Yes, submit!",
                onConfirm: () => handleRequest(),
                onUserMessageChange: (msg) => {
                  userMessageRef.current = msg;
                },
              });
            }}
            className="w-1/2"
          />
          <button
            onClick={() =>
              navigate(
                SETTINGS.get_path({
                  section: AppSections.CHELEMENTS,
                })
              )
            }
            className="w-1/2 bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition duration-200"
          >
            Back to Records
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserRoleUpdate;
